import React, { useState, useEffect } from "react";
import Image from "../../components/common/Image";
import Step1 from "./Step1";
import Step2 from "./Step2";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const Identity = () => {
  const identities = useSelector((state) => state.user.identities);
  const [queryParameters] = useSearchParams()
  const key = queryParameters.get("key")?queryParameters.get("key")*1:1
  const [step, setStep] = useState(key);
  const navigate = useNavigate()
  useEffect(()=>{
    setStep(key)
  },[key])
  return (
    <div className='container'>
      <div className="page-header">
        <button className="btn-circle" onClick={()=>{
          // navigate(-1)
          navigate('/services')
        }}>
          <Image src="/images/icons/close.svg" svg />
        </button>
        <div className="page_header__title">
          <h1 className="font-heading">{step === 1 ? "帶入" : ""}優惠身份</h1>
          { step === 1 && (
            <p className="text-secondary text-scale-02">
              依照身份類型填入相關欄位
            </p>
          )}
        </div>
      </div>
      {
        step ===1 ?(<Step1 
          identities={identities}
          navigate={navigate} 
          setStep={(val)=>setStep(val)}/>):
        (<Step2  
          identities={identities}
          navigate={navigate} 
          setStep={(val)=> setStep(val)}
        />)
      }
    </div>
  );
};

export default Identity;
